import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import NotFound from 'modules/core/components/NotFound'

import { useFetchContractsPermissions } from 'modules/contracts/hooks/useFetchContractsPermissions'
import { useContractFlow } from 'modules/contracts/lib/contractFlowContext'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import RequestPromoteFlowContent from './_RequestPromoteFlowContent'

const Loading = () => {
  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center">
      <Spinner />
    </Box>
  )
}

const RequestPromoteFlow = () => {
  const { employee } = useContractFlow()
  const { loading: loadingPermissions } = useFetchContractsPermissions(employee)

  if (loadingPermissions) return <Loading />
  const canPromote = policyAuthorizations.for('contracts.promote', employee)
  if (!canPromote) return <NotFound />
  return <RequestPromoteFlowContent />
}

export default observer(RequestPromoteFlow)
